// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"c15496d4","208":"92d1a5d6","473":"f15cee0e","484":"8d8be71f","488":"a8be7434","532":"c59e4080","760":"a61f35bd","787":"2ba137f2","883":"89610ad5","916":"a9d5b50a","997":"f5f02a3d"}[chunkId] + ".chunk.js";
};